<template>
  <div class="w-full rounded border border-gray-200">
      <!-- Header -->
      <div class="bg-gray-300 text-gray-800 p-2">
          <h5>
              {{appTitle}}
          </h5>
          <div class="border-t border-gray-200">
                <p>Available Actions</p>
                <button v-if="newForm == false" @click="newForm = true" class="border-2 border-teal-100 bg-teal-200 text-teal-600 p-1 mx">New</button>
          </div>
      </div>
      <!-- body -->
        <div class="bg-gray-100">
            <!-- form -->
            <div class="p-2" v-if="newForm">
                <div v-for="(field,indexField) in fields.form" :key="indexField">
                    <label :for="field.title">{{field.title}}</label>
                    <input v-model="newRecord[field.title]" class="w-full" :name="field.title" :type="field.type">
                </div>
                <button @click="saveNewRecord" class="border-2 border-teal-100 bg-teal-200 text-teal-600 p-1 mx">Save</button>
            </div>
            <!-- Data -->
            <table class="w-full">
                <thead>
                    <tr>
                        <th class="w-1/6">#</th>
                        <th v-for="(field,indexField) in fields.table" :key="indexField">{{field}}</th>
                        <th class="w-2/6">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row,rowIndex) in all" v-bind:key="rowIndex">
                        <td class="text-center w-1/6">{{row.id}}</td>
                        <td v-for="(field,indexField) in fields.table" :key="indexField">
                            <template v-if="!row.edit">{{row[field]}}</template>
                            <template v-if="row.edit == true"><input v-model="row[field]" /></template>
                        </td>
                        <td class="w-2/6">
                            <button class="border-2 border-red-100 bg-red-200 text-red-600 p-2 mx" @click="deleteRecord(rowIndex)">Delete</button>
                            <button class="border-2 border-blue-100 bg-blue-200 text-blue-600 p-2 mx" @click="copyNewRecord(rowIndex)">Copy Content</button>
                            <button class="border-2 border-green-100 bg-green-200 text-green-600 p-2 mx" v-if="row.edit == true" @click="editRecordEvent(rowIndex)">Update</button>
                            <button class="border-2 border-green-100 bg-green-200 text-green-600 p-2 mx" v-if="!row.edit" @click="row.edit = true">Edit</button>
                            <!-- <button class="border-2 border-teal-100 bg-teal-200 text-teal-600 p-2 mx">Show</button> -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
  </div>
</template>

<script>
export default {
    props:[
        'appTitle',
        'fields',
        'urls'
    ],
    data(){
        return {
            newForm: false,
            newRecord: {},
            all:[]
        };
    },created(){
        axios.get(this.urls.all).then(r=>{
            this.all = r.data.map(row => {
                row['edit'] = false;
                return row;
            });
        })
        for (let i = 0; i < this.fields.form.length; i++) {
            this.newRecord[this.fields.form[i].name] = '';
        }
    },
    methods:{
        saveNewRecord(){

            axios.post(this.urls.store,this.newRecord).then((r) => {
                this.all.push(r.data);
                for (let i = 0; i < this.newRecord.length; i++){
                    this.newRecord[i] = null;
                }
                this.newForm = false;
                this.$q.notify({
                    message: 'Saved',
                    color: 'purple'
                });
            });
        },
        copyNewRecord(key){
            axios.post(this.urls.store,this.all[key]).then((r) => {
                this.all.push(r.data);
                this.newForm = false;
                this.$q.notify({
                    message: 'Saved',
                    color: 'purple'
                });
            });
        },
        deleteRecord(rowKey){
        var r = confirm("Do you Realy Want to remove ?");
        if (r == true) {
          axios.delete(this.urls.destroy + '/' +  this.all[rowKey].id).then(r=>{
            this.all.splice(rowKey, 1)
                this.$q.notify({
                    message: 'Deleted',
                    color: 'red'
                });
          });
        }

        
      },
      editRecordEvent(rowKey){
        axios.put(this.urls.update,this.all[rowKey]).then(r=>{
            this.all[rowKey].edit = 0;
            this.$q.notify({
                message: 'Saved',
                color: 'purple'
            });
        })
      },
    }
}
/*

<crud 
    :urls="{
        'all':'api/Project/Project/all',
        'store':'api/Project/Project/store',
        'update':'api/Project/Project/update',
        'destroy': 'api/Project/Project/destroy'
    }" 
    :fields="{
        'table':['title','created_at'],
        'form':[{'type':'text','title':'title'}]
    }" 
    app-title="Todo App"
></crud>

*/
</script>

